"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _DeviceSettings = _interopRequireDefault(require("./DeviceSettings"));
var _NotificationSettings = require("./NotificationSettings");
var _LayoutSettings = require("./LayoutSettings");
var _common = require("./common.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SettingsModal = function SettingsModal(_ref) {
  var open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    children = _ref.children;
  var mediaQueryLg = _reactUi.config.media.md;
  var isMobile = (0, _reactUse.useMedia)(mediaQueryLg);
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  var resetSelection = (0, _react.useCallback)(function () {
    setSelection("");
  }, []);
  (0, _react.useEffect)(function () {
    setSelection(isMobile ? "" : "devices");
  }, [isMobile]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Root, {
    open: open,
    onOpenChange: onOpenChange,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Trigger, {
      asChild: true,
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Portal, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Overlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Content, {
        css: {
          w: "min(800px, 90%)",
          height: "min(656px, 90%)",
          p: 0,
          r: "$4"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.Root, {
          value: selection,
          activationMode: isMobile ? "manual" : "automatic",
          onValueChange: setSelection,
          css: {
            size: "100%",
            position: "relative"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.List, {
            css: {
              w: isMobile ? "100%" : "18.625rem",
              flexDirection: "column",
              bg: "$backgroundDefault",
              p: "$14 $10",
              borderTopLeftRadius: "$4",
              borderBottomLeftRadius: "$4"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
              variant: "h5",
              children: "Settings "
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
              direction: "column",
              css: {
                mx: isMobile ? "-$8" : 0,
                overflowY: "auto"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.Trigger, {
                value: "devices",
                css: {
                  gap: "$8",
                  mt: "$10",
                  mb: "$4"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SettingsIcon, {}), "Device Settings"]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.Trigger, {
                value: "notifications",
                css: {
                  gap: "$8"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.NotificationsIcon, {}), "Notifications"]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.Trigger, {
                value: "layout",
                css: {
                  gap: "$8"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.GridFourIcon, {}), "Layout"]
              })]
            })]
          }), selection && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
            direction: "column",
            css: _objectSpread({
              flex: "1 1 0",
              minWidth: 0,
              mr: "$4"
            }, isMobile ? {
              position: "absolute",
              left: 0,
              right: 0,
              bg: "$surfaceDefault",
              width: "100%",
              height: "100%"
            } : {}),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.Content, {
              value: "devices",
              className: (0, _common.settingContent)(),
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SettingsContentHeader, {
                onBack: resetSelection,
                isMobile: isMobile,
                children: "Device Settings"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeviceSettings["default"], {})]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.Content, {
              value: "notifications",
              className: (0, _common.settingContent)(),
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SettingsContentHeader, {
                onBack: resetSelection,
                isMobile: isMobile,
                children: "Notifications"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationSettings.NotificationSettings, {})]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Tabs.Content, {
              value: "layout",
              className: (0, _common.settingContent)(),
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SettingsContentHeader, {
                onBack: resetSelection,
                isMobile: isMobile,
                children: "Layout"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LayoutSettings.LayoutSettings, {})]
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Close, {
          css: {
            position: "absolute",
            right: "$10",
            top: "$10",
            background: 'none',
            border: 'none'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
            as: "div",
            "data-testid": "dialog_cross_icon",
            css: {},
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CrossIcon, {})
          })
        })]
      })]
    })]
  });
};
var SettingsContentHeader = function SettingsContentHeader(_ref2) {
  var children = _ref2.children,
    isMobile = _ref2.isMobile,
    onBack = _ref2.onBack;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
    variant: "h6",
    css: {
      mb: "$12",
      display: "flex",
      alignItems: "center"
    },
    children: [isMobile && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      as: "span",
      css: {
        bg: "$surfaceLight",
        mr: "$4",
        r: "$round",
        p: "$2"
      },
      onClick: onBack,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronLeftIcon, {})
    }), children]
  });
};
var _default = SettingsModal;
exports["default"] = _default;